//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"

vue.use(vuex);

//store
const meta = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api`,
    state: {
        Ametas: [],
        metasvigencia: [],
        Ametascuatrenio: [],
        metasvigenciaext: [],
        Ametascuatrenioext: [],  
        metastemporales: [],      
        AEstadoMeta: 0,
    }
}).get({
    action: "getmeta",   
    path: function (obj) {
        return `/meta/${obj.idMeta}`;
    },
    onSuccess: (state, payload ) => {
        state.Ametas = payload.data;
    }
}).get({
    action: "getmetasperiodo",   
    path: function (obj) {
        return `/meta/metasperiodo/${obj.idindicador}/${obj.idperiodo}`;
    },
    onSuccess: (state, payload ) => {
        state.Ametas = payload.data;
    }
}).get({
    action: "get_metasvigencia",   
    path: function (obj) {        
        return `/meta/metasperiodicidad/${obj.idindicador}/V`;
    },
    onSuccess: (state, payload ) => {
        state.metasvigencia = payload.data;
    }
}).get({
    action: "metascuatrenio",   
    path: function (obj) {
        return `/meta/metasperiodicidad/${obj.idindicador}/C`;
    }, 
    onSuccess: (state, payload ) => {        
        state.Ametascuatrenio = payload.data;
    }
}).get({
    action: "get_metasvigenciaExt",   
    path: function (obj) {        
        return `/meta/metasperiodicidadext/${obj.idindicador}/V`;
    },
    onSuccess: (state, payload ) => {
        state.metasvigenciaext = payload.data;
    }
}).get({
    action: "get_metastemporales",   
    path: function (obj) {        
        return `/meta/metastemporales/${obj.idindicador}`;
    },
    onSuccess: (state, payload ) => {
        state.metastemporales = payload.data;
    }
}).get({
    action: "get_metascuatrenioExt",   
    path: function (obj) {
        return `/meta/metasperiodicidadext/${obj.idindicador}/C`;
    }, 
    onSuccess: (state, payload ) => {        
        state.Ametascuatrenioext = payload.data;
    }
}).get({
    action: "estadometasnulas",   
    path: function (obj) {
        return `/meta/estadometasedicion/${obj.idindicador}`;
    }, 
    onSuccess: (state, payload ) => {        
        state.AEstadoMeta = payload.data;
    }
}).put({
    action: "cambiarestadometa",
    path: function () {
        return `/meta/cambiarestadometa`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        state.Aindicador.finalizar = false;
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

meta.getters = {
    gmetas: state => {
        return state.Ametas;
    },
    gmetasvigencia: state =>{
        return state.metasvigencia;
    },
    gmetastemporales: state =>{
        return state.metastemporales;
    },
    gmetasvigenciaext: state =>{
        return state.metasvigenciaext.filter(X => X.extemporaneo == true);
    },
    gmetasvigenciasinext: state =>{
        return state.metasvigenciaext.filter(X => X.extemporaneo == false);
    },
    gmetasvigenciavencida: state =>{
        var d = new Date();
        var n = d.getFullYear();
        return state.metasvigencia.filter(p=> p.valor !== null && p.periodo<=n );
    },
    gmetasvigenciavencidawithext: state =>{        
        return state.metasvigencia.filter(p=> (p.valor != null || p.avance != null ) && (p.extemporaneo == false || (p.extemporaneo == true && p.ultimoext == true) ) && (p.idestado == 6) );
    },
    gmetasvigenciavisibles: state =>{
        var d = new Date();
        var n = d.getFullYear();
        return state.metasvigencia.filter(p=> p.valor !== null || p.periodo<=n );
    },
    gmetascuatrenio: state =>{
        return state.Ametascuatrenio;
    },
    gmetascuatrenioext: state =>{
        return state.Ametascuatrenioext.filter(X => X.extemporaneo == true);
    },
    gmetascuatreniosinext: state =>{
        return state.Ametascuatrenioext.filter(X => X.extemporaneo == false);
    },
    gmetascuatrenioavance: state =>{
        return state.Ametascuatrenio;
    }
    ,
    gmetasvigenciaconavance: state => { 
        if (state.metasvigencia !== undefined)
        {
        return state.metasvigencia.filter(p=> p.avance !== null)
        }
    },    
    gultimameta: state => {       
        let ultima = state.metasvigencia.filter(p => p.ultimo === true)[0];
        if (ultima != undefined) {
            let avances = ultima.avanceCuantitativo.filter(p => p.ultimo === true);
            if (avances.length > 0) {
                return avances[0].fechacorte;
            }
            else {
                return "";
            }
        }
        else {
            return "";
        }
    },
    gestadometanula: state => {
        return state.AEstadoMeta;
    }
}

export default meta;